// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3A712","mainLink":"header-module--main-link--QRcys","activeLink":"header-module--active-link--F4wk-"};